import { storage_keys } from '@/constant/configs';
import {
  setRestaurantTokenToCookie,
  removeRestaurantToken,
} from '@/lib/actions/restaurant';
import { restaurant } from '@/lib/utils/routeLinks';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { logOut } from '@/clients/restaurant/auth';
import toast from 'react-hot-toast';
import { UserType } from '@/lib/types/restaurant/User';
import {
  removeRestaurantAuthCreds,
  removeRestaurantImpersonateIDs,
} from '@/lib/utils/functions';
import { deleteFCMToken } from '@/lib/utils/fcm-cleanup';
interface AuthResponse {
  data: {
    token: string;
    refresh_token: string;
    user: UserType;
    token_expires_at: string;
  };
}

export default function useRestaurantAuth() {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleRestaurantLogin = async (
    res: AuthResponse,
    setUser: (user: UserType) => void
  ) => {
    try {
      localStorage.removeItem(storage_keys.customer_cart);
      // Remove impersonate id if available
      localStorage.removeItem(storage_keys.res_impersonate_id);
      localStorage.setItem(storage_keys.restaurant_token, res.data.token);
      localStorage.setItem(
        storage_keys.restaurant_refresh_token,
        res.data.refresh_token
      );

      await setRestaurantTokenToCookie(
        res.data.token,
        res.data.token_expires_at
      );
      await setUser(res.data.user);

      if (pathname.includes('unternehmen/login')) {
        const hasActiveSubscribtion =
          res?.data?.user?.related_restaurant?.active_subscription
            ?.free_of_charge;

        const redirectInParams = searchParams.get('redirect');

        let redirectUrl = restaurant.subscriptions.de();

        if (redirectInParams) {
          redirectUrl = redirectInParams;
        } else if (!hasActiveSubscribtion) {
          redirectUrl = restaurant.dashboard.de();
        } else {
          redirectUrl = restaurant.subscriptions.de();
        }

        router.push(redirectUrl);
      }
    } catch (error) {
      toast.error('Login failed. Please try again.');
    }
  };

  const handleRestaurantLogout = (
    removeUser: () => void,
    impersonateId: string | boolean
  ) => {
    if (!impersonateId) {
      logOut()
        .then(async () => {
          await deleteFCMToken();
          removeRestaurantAuth(removeUser);
        })
        .catch((err) => {
          toast.error(err?.response?.message);
        });
    } else {
      removeRestaurantAuth(removeUser);
    }
  };

  const removeRestaurantAuth = async (
    removeUser: () => void,
    redirect = true
  ) => {
    await deleteFCMToken();
    removeRestaurantAuthCreds();
    // Remove impersonate id if available
    removeRestaurantImpersonateIDs();
    removeUser();
    removeRestaurantToken();

    if (redirect) {
      window.location.href = restaurant.login.de();
    }
  };

  const checkRestaurantAuthAndRedirect = () => {
    const token = localStorage.getItem(storage_keys.restaurant_token);
    if (token) {
      router.push(restaurant.dashboard.de());
    }
  };

  return {
    handleRestaurantLogin,
    checkRestaurantAuthAndRedirect,
    handleRestaurantLogout,
    removeRestaurantAuth,
  };
}
